'use client';

import { useEffect } from 'react';

export const HeaderScrollDecoration = () => {
  useEffect(() => {
    const header = document.querySelector('[data-server-header="true"]');
    const trigger = document.querySelector('[data-section]');

    if (!header || !trigger) {
      return;
    }

    const updateDecoration = () => {
      header.toggleAttribute(
        'data-scrolled',
        trigger.getBoundingClientRect().top <= 70
      );
    };

    updateDecoration();
    window.addEventListener('scroll', updateDecoration, { passive: true });

    return () => {
      window.removeEventListener('scroll', updateDecoration);
      header.removeAttribute('data-scrolled');
    };
  }, []);

  return null;
};
